<template>
  <v-dialog v-model="showModal" width="500">
    <v-card
      class="d-flex flex-column align-center justify-space-around"
      :class="$vuetify.breakpoint.xsOnly ? 'pa-6' : 'pa-10'"
      height="250"
    >
      <div class="fw500 text-center" :class="$vuetify.breakpoint.xsOnly ? 'f20' : 'f24'">
        {{ localStorage.mobile.pages.mob_modal.common.confirm_exit_message }}
      </div>
      <v-card tile flat width="100%" class="d-flex justify-space-around align-center">
        <v-btn @click="logout()" class="text-none br15" dark color="#277faf" x-large outlined>
          {{ localStorage.mobile.pages.mob_modal.common.yes }}
        </v-btn>
        <v-btn @click="showModal = false" class="text-none br15" dark color="#277faf" x-large>
          {{ localStorage.mobile.pages.mob_modal.common.no }}
        </v-btn>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HeaderLogoutModal',
  props: {
    modal: Boolean,
  },
  data() {
    return {
      showModal: false,
    }
  },
  watch: {
    modal() {
      if (this.modal) {
        this.showModal = this.modal
      }
    },
    showModal() {
      if (!this.showModal) {
        this.$emit('exit', false)
      }
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' }).catch(() => {})
      })
    },
  },
}
</script>
